module.exports = __webpack_public_path__ + "assets/img/tedian1.966a1737.png";